import { UserPermissions } from './UserTypes';

export interface BulkModifyAccountsResponse {
  total: number;
  successCount: number;
  failedCount: number;
  successful: string[];
  failed: { accountId: string; error: string }[];
}

export enum AdminTask {
  bulkEnrollDomesticContent = 'bulkEnrollDomesticContent',
  grantPtoGreenlight = 'grantPtoGreenlight',
  organizationUserExport = 'organizationUserExport',
  orgVisibility = 'orgVisibility',
  avlImport = 'avlImport',
  addFeocException = 'addFeocException',
  moveToStrandedAssetTeam = 'moveToStrandedAssetTeam',
  replayFailedDirectPayLogs = 'replayFailedDirectPayLogs',
  replayFailedConcordLogs = 'replayFailedConcordLogs',
}

export const AdminTaskMap: Record<AdminTask, { title: string; neededPermissions: UserPermissions[] }> = {
  bulkEnrollDomesticContent: {
    title: 'Bulk Enroll Domestic Content',
    neededPermissions: [UserPermissions.lightReachSupport],
  },
  grantPtoGreenlight: { title: 'Grant PTO Greenlight', neededPermissions: [] },
  organizationUserExport: { title: 'Organization User Export', neededPermissions: [] },
  orgVisibility: { title: 'Organization Visibility', neededPermissions: [] },
  avlImport: { title: 'Import AVL', neededPermissions: [UserPermissions.canImportAvlData] },
  addFeocException: { title: 'Add FEOC Exception', neededPermissions: [UserPermissions.lightReachSupport] },
  moveToStrandedAssetTeam: {
    title: 'Bulk Assign/Unassign to Untrancheable Asset Team',
    neededPermissions: [UserPermissions.admin],
  },
  replayFailedDirectPayLogs: {
    title: 'Replay Failed Direct Pay Logs',
    neededPermissions: [UserPermissions.lightReachTaskAdmin],
  },
  replayFailedConcordLogs: {
    title: 'Replay Failed Concord Logs',
    neededPermissions: [UserPermissions.lightReachTaskAdmin],
  },
};
